import React from 'react';
import { MDBContainer, MDBRow, MDBCol, MDBIcon, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader } from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import CardContent from '@material-ui/core/CardContent';
import { DatePicker, Image, TreeSelect, message } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import InsideTable from '../../component/insideTable/insideTable';
import './project info.css';
import moment from 'moment';

const { TreeNode } = TreeSelect;

// Component for the image section 
export const ImageSection = ({ state, img }) => (
    <MDBCol xl="4" lg="5" md="12" sm="12">
        <div className="infoCard">
            <div style={{ width: "100%", padding: '10px' }}>
                <Image
                    width="100%"
                    height="100%"
                    style={{ objectFit: 'cover', borderRadius: '6px', width: "100%", height: '280px' }}
                    src={state.imgType === "data" ? URL.createObjectURL(state.img) : img}
                />
            </div>
        </div>
    </MDBCol>
);
const theTargetSales = (state, isRTL, allStrings, handleChangeState) => {
    return state.targetSales.map((v, i) =>
        <MDBRow>
            {state.actionType === "EDIT" &&
                <MDBCol md="2">
                    {i > 0 &&
                        <div className="minusInput" onClick={() => removeOptionsInput(i, state.targetSales, handleChangeState)}>
                            <MDBIcon icon="trash" className="mr-2" />
                        </div>
                    }
                    {i === state.targetSales.length - 1 &&
                        <div className="addInputInner" onClick={() => {
                            const newTargetSales = [
                                ...state.targetSales,
                                { monthDate: null, ratio: 0, target: 0 }
                            ];
                            handleChangeState('targetSales', newTargetSales);
                        }}>
                            <MDBIcon icon="plus" className="mr-2" />
                        </div>
                    }
                </MDBCol>
            }
            <MDBCol md="3">
                <div className="md-form">
                    <label htmlFor="form2" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.ratio}</label>
                    <input value={v.ratio} disabled={state.actionType === "VIEW" ? true : false} style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }}
                        type="number" id="form2" min={0} name="ratio" className="form-control"
                        onChange={(event) => {
                            let targetSales = [...state.targetSales];
                            let toEnglishDigits = s => String(s).replace(/[٠-٩]/g, d => '0123456789'['٠١٢٣٤٥٦٧٨٩'.indexOf(d)]);
                            targetSales[i].ratio = toEnglishDigits(event.target.value);
                            targetSales[i].target = (toEnglishDigits(event.target.value) / 100) * state.totalPrice;
                            handleChangeState(targetSales, targetSales);
                        }} required validate placeholder="أدخل النسبة..." />
                    <div class="valid-feedback">{allStrings.correct}</div>
                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                </div>
            </MDBCol>
            <MDBCol md="3">
                <div className="md-form">
                    <label htmlFor="form2" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.targetDeals}</label>
                    <input value={v.target} disabled={state.actionType === "VIEW" ? true : false} style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }}
                        type="number" id="form2" min={0} name="target" className="form-control"
                        onChange={(event) => {
                            let targetSales = [...state.targetSales];
                            let toEnglishDigits = s => String(s).replace(/[٠-٩]/g, d => '0123456789'['٠١٢٣٤٥٦٧٨٩'.indexOf(d)]);
                            targetSales[i].target = toEnglishDigits(event.target.value);
                            targetSales[i].ratio = (toEnglishDigits(event.target.value) / state.totalPrice) * 100;
                            targetSales[i].ratio = Math.floor(targetSales[i].ratio * 10) / 10;
                            handleChangeState(targetSales, targetSales);
                        }} required validate placeholder="أدخل الهدف..." />
                    <div class="valid-feedback">{allStrings.correct}</div>
                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                </div>
            </MDBCol>
            <MDBCol md={state.actionType === "EDIT" ? "4" : "6"}>
                <div className="md-form">
                    <label htmlFor="form2" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%', marginBottom: '10px' }}>{allStrings.date}</label>
                    <DatePicker
                        dropdownAlign={{ points: ['bl', 'tl'] }}
                        placement="topLeft"
                        defaultValue={v.monthDate ? moment(v.monthDate) : null}
                        disabled={state.actionType === "VIEW" ? true : false}
                        showTime={{ use12Hours: true, format: 'h:mm A' }}
                        style={{ width: '100%', marginTop: '8px', textAlign: isRTL ? 'right' : 'left', marginBottom: '1rem' }}
                        onChange={(date, dateString) => {
                            console.log(dateString)
                            let targetSales = [...state.targetSales];
                            targetSales[i].monthDate = dateString;
                            handleChangeState(targetSales, targetSales);
                        }}
                        placeholder={allStrings.date}
                    />
                </div>
            </MDBCol>

        </MDBRow>

    )
}
const removeOptionsInput = (i, targetSales, handleChangeState) => {
    let theTargetSales = [...targetSales];
    console.log(i)
    theTargetSales.splice(i, 1);
    console.log("targetSales", theTargetSales)
    handleChangeState("targetSales", theTargetSales);
}
//collect money
export const ModalForFinancialCollection = ({ isOpen, toggle, submitHandler, state, isRTL, allStrings, handleChangeState, fileChangedHandler, removeReciept }) => (
    <MDBModal isOpen={isOpen} toggle={toggle} size="lg">
        <MDBModalHeader toggle={toggle} >{allStrings.completeData}</MDBModalHeader>
        <MDBModalBody>
            <MDBContainer>
                <MDBRow>
                    <MDBCol md="12">
                        <form style={{ paddingTop: '1rem' }}
                            className="needs-validation"
                            onSubmit={submitHandler}
                            noValidate
                        >
                            <div className="grey-text">
                                <MDBRow>
                                    <MDBCol md="12">
                                        <label className="customLabel" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.units}</label>
                                        <TreeSelect virtual={false}
                                            showSearch={true}
                                            style={{ width: '100%', textAlign: isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                            treeCheckable={true}
                                            treeNodeFilterProp="title"
                                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                            placeholder={allStrings.unit}
                                            onChange={(value) => {
                                                console.log(value)
                                                handleChangeState('collectedForUnits', value)
                                            }}

                                        >
                                            {Array.isArray(state.projectUnits) && state.projectUnits.map(val => (
                                                <TreeNode value={val.id} title={val.unitNumber} key={val.id} />
                                            ))}
                                        </TreeSelect>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div className="fileUpload2">
                                            <input key={state.collectionReciept} type='file' className="upImgs2" onChange={fileChangedHandler}></input>
                                            <span className="uploadParent"><UploadOutlined style={{ color: '#000', fontSize: '14px', position: 'relative', top: '-3px', marginRight: '2px' }} /><span className="uploadName">{allStrings.collectionReciept}</span></span>
                                        </div>
                                        <div className="preview">
                                            {state.collectionReciept &&
                                                <div style={{ display: "inline-block", width: '100%', border: '1px solid mediumaquamarine' }}>
                                                    <img alt="" src={URL.createObjectURL(state.collectionReciept)} className="previewImg2" />
                                                    <span className="imgName">{state.collectionRecieptName}</span>
                                                    <MDBIcon icon="trash" className="mr-2 removeImg2" onClick={removeReciept}></MDBIcon>
                                                </div>
                                            }
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                            </div>
                            <div className="drawer-action-footer">
                                <MDBBtn type="button" className="btn-cancel" onClick={toggle}>
                                    إلغاء
                                </MDBBtn>
                                <MDBBtn type="submit" className="btn-submit">
                                    {allStrings.send}
                                </MDBBtn>
                            </div>
                        </form>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </MDBModalBody>
    </MDBModal>
);
//collect money
export const ModalForMedia = ({ isOpen, toggle, submitHandlerMedia, state, allStrings, fileChangedHandlerMedia, removeMedia, fileChangedHandlerThumbnail, removeThumbnail }) => (
    <MDBModal isOpen={isOpen} toggle={toggle} size="lg">
        <MDBModalHeader toggle={toggle} >{allStrings.completeData}</MDBModalHeader>
        <MDBModalBody>
            <MDBContainer>
                <MDBRow>
                    <MDBCol md="12">
                        <form style={{ paddingTop: '1rem' }}
                            className="needs-validation"
                            onSubmit={submitHandlerMedia}
                            noValidate
                        >
                            <div className="grey-text">
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div className="fileUpload2">
                                            <input key={state.removeAsset} type='file' className="upImgs2" onChange={fileChangedHandlerMedia}></input>
                                            <span className="uploadParent"><UploadOutlined style={{ color: '#000', fontSize: '14px', position: 'relative', top: '-3px', marginRight: '2px' }} /><span className="uploadName">{allStrings.media}</span></span>
                                        </div>
                                        <div className="preview">
                                            {state.media &&
                                                <div style={{ display: "inline-block", width: '100%', border: '1px solid mediumaquamarine' }}>
                                                    <img alt="" src={URL.createObjectURL(state.media)} className="previewImg2" />
                                                    <span className="imgName">{state.mediaName}</span>
                                                    <MDBIcon icon="trash" className="mr-2 removeImg2" onClick={removeMedia}></MDBIcon>
                                                </div>
                                            }
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div className="fileUpload2">
                                            <input key={state.thumbnail} type='file' className="upImgs2" onChange={fileChangedHandlerThumbnail}></input>
                                            <span className="uploadParent"><UploadOutlined style={{ color: '#000', fontSize: '14px', position: 'relative', top: '-3px', marginRight: '2px' }} /><span className="uploadName">{allStrings.thumbnail}</span></span>
                                        </div>
                                        <div className="preview">
                                            {state.thumbnail &&
                                                <div style={{ display: "inline-block", width: '100%', border: '1px solid mediumaquamarine' }}>
                                                    <img alt="" src={URL.createObjectURL(state.thumbnail)} className="previewImg2" />
                                                    <span className="imgName">{state.thumbnailName}</span>
                                                    <MDBIcon icon="trash" className="mr-2 removeImg2" onClick={removeThumbnail}></MDBIcon>
                                                </div>
                                            }
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                            </div>
                            <div className="drawer-action-footer">
                                <MDBBtn type="button" className="btn-cancel" onClick={toggle}>
                                    إلغاء
                                </MDBBtn>
                                <MDBBtn type="submit" className="btn-submit">
                                    {allStrings.send}
                                </MDBBtn>
                            </div>
                        </form>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </MDBModalBody>
    </MDBModal>
);

export const ModalForAttachment = ({ isOpen, toggle, submitHandlerAttachment, state, allStrings, fileChangedHandlerAttachment, removeAttachmentFile, handleChangeState, isRTL }) => (
    <MDBModal isOpen={isOpen} toggle={toggle} size="lg">
        <MDBModalHeader toggle={toggle} >{allStrings.completeData}</MDBModalHeader>
        <MDBModalBody>
            <MDBContainer>
                <MDBRow>
                    <MDBCol md="12">
                        <form style={{ paddingTop: '1rem' }}
                            className="needs-validation"
                            onSubmit={submitHandlerAttachment}
                            noValidate
                        >
                            <div className="grey-text">
                                <MDBRow>
                                    <MDBCol md="6">
                                        <div className="md-form">
                                            <label htmlFor="attachmentContent" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.fileNumber}</label>
                                            <input style={{ direction: isRTL ? 'rtl' : 'ltr' }} value={state.fileNumber} type="text" id="attachmentNumber" name="fileNumber" className="form-control" onChange={(e) => handleChangeState('fileNumber', e.target.value)} required validate placeholder="أدخل البيانات..." />
                                        </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                        <label className="customLabel" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.content}</label>
                                        <TreeSelect virtual={false}
                                            showSearch={true}
                                            style={{ width: '100%', textAlign: isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                            treeCheckable={false}
                                            treeNodeFilterProp="title"
                                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                            placeholder={allStrings.type}
                                            onChange={(value) => {
                                                console.log(value)
                                                handleChangeState('attachmentContent', value)
                                            }}


                                        >
                                            <TreeNode value="رخصه بناء" title="رخصه بناء" key="رخصه بناء" />
                                            <TreeNode value="سجل تجارى" title="سجل تجارى" key="سجل تجارى" />
                                            <TreeNode value="هويه المالك" title="هويه المالك" key="هويه المالك" />
                                            <TreeNode value="شهاده الاشغال" title="شهاده الاشغال" key="شهاده الاشغال" />
                                            <TreeNode value="شهاده اطلاق التيار الكهربائي" title="شهاده اطلاق التيار الكهربائي" key="شهاده اطلاق التيار الكهربائي" />
                                            <TreeNode value="عقد الوساطه" title="عقد الوساطه" key="عقد الوساطه" />

                                        </TreeSelect>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow style={{ flexFlow: isRTL ? 'row-reverse' : 'row' }} >
                                    <MDBCol md="6">
                                        <div className="md-form">
                                            <label style={{ textAlign: isRTL ? 'right' : 'left', width: '100%', marginBottom: '10px' }}>{allStrings.startDate}</label>
                                            <DatePicker
                                                dropdownAlign={{ points: ['bl', 'tl'] }}
                                                placement="topLeft"
                                                value={state.attachmentStartDate ? moment(state.attachmentStartDate) : null}
                                                style={{ width: '100%', marginTop: '8px', textAlign: isRTL ? 'right' : 'left', marginBottom: '1rem' }}
                                                onChange={(date, dateString) => handleChangeState('attachmentStartDate', dateString)}
                                                placeholder={allStrings.startDate}
                                            />
                                        </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                        <div className="md-form">
                                            <label style={{ textAlign: isRTL ? 'right' : 'left', width: '100%', marginBottom: '10px' }}>{allStrings.endDate}</label>
                                            <DatePicker
                                                dropdownAlign={{ points: ['bl', 'tl'] }}
                                                placement="topLeft"
                                                value={state.attachmentEndDate ? moment(state.attachmentEndDate) : null}
                                                style={{ width: '100%', marginTop: '8px', textAlign: isRTL ? 'right' : 'left', marginBottom: '1rem' }}
                                                onChange={(date, dateString) => handleChangeState('attachmentEndDate', dateString)}
                                                placeholder={allStrings.endDate}
                                            />
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div className="fileUpload2">
                                            <input key={state.attachment} type='file' className="upImgs2" onChange={fileChangedHandlerAttachment}></input>
                                            <span className="uploadParent"><UploadOutlined style={{ color: '#000', fontSize: '14px', position: 'relative', top: '-3px', marginRight: '2px' }} /><span className="uploadName">{allStrings.file}</span></span>
                                        </div>
                                        <div className="preview">
                                            {state.attachment &&
                                                <div style={{ display: "inline-block", width: '100%', border: '1px solid mediumaquamarine' }}>
                                                    <img alt="" src={URL.createObjectURL(state.attachment)} className="previewImg2" />
                                                    <span className="imgName">{state.attachmentName}</span>
                                                    <MDBIcon icon="trash" className="mr-2 removeImg2" onClick={removeAttachmentFile}></MDBIcon>
                                                </div>
                                            }
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                            </div>
                            <div className="drawer-action-footer">
                                <MDBBtn type="button" className="btn-cancel" onClick={toggle}>
                                    إلغاء
                                </MDBBtn>
                                <MDBBtn type="submit" className="btn-submit">
                                    {allStrings.send}
                                </MDBBtn>
                            </div>
                        </form>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </MDBModalBody>
    </MDBModal>
);

export const ModalForCampaign = ({ isOpen, toggle, submitHandlerCampaign, state, allStrings, handleChangeState, isRTL }) => (
    <MDBModal isOpen={isOpen} toggle={toggle} size="lg">
        <MDBModalHeader toggle={toggle} >{allStrings.completeData}</MDBModalHeader>
        <MDBModalBody>
            <MDBContainer>
                <MDBRow>
                    <MDBCol md="12">
                        <form style={{ paddingTop: '1rem' }}
                            className="needs-validation"
                            onSubmit={submitHandlerCampaign}
                            noValidate
                        >
                            <div className="grey-text">
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div className="md-form">
                                            <label htmlFor="campaignContent" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.content}</label>
                                            <input style={{ direction: isRTL ? 'rtl' : 'ltr' }} value={state.campaignContent} type="text" id="campaignContent" name="campaignContent" className="form-control" onChange={(e) => handleChangeState('campaignContent', e.target.value)} required validate placeholder="أدخل البيانات..." />
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <label className="customLabel" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.campaignType}</label>
                                        <TreeSelect virtual={false}
                                            showSearch={true}
                                            style={{ width: '100%', textAlign: isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                            treeCheckable={false}
                                            treeNodeFilterProp="title"
                                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                            placeholder={allStrings.campaignType}
                                            onChange={(value) => {
                                                console.log(value)
                                                handleChangeState('campaignType', value)
                                            }}

                                        >
                                            <TreeNode value="SNAPCHAT" title={allStrings.snapChat} key="SNAPCHAT" />
                                            <TreeNode value="FACEBOOK" title={allStrings.facebook} key="FACEBOOK" />
                                            <TreeNode value="INSTAGRAM" title={allStrings.instagram} key="INSTAGRAM" />
                                            <TreeNode value="TIKTOK" title={allStrings.tiktok} key="TIKTOK" />
                                            <TreeNode value="BOARD" title={allStrings.board} key="BOARD" />
                                            <TreeNode value="NONE" title={allStrings.other} key="NONE" />

                                        </TreeSelect>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div className="md-form">
                                            <label htmlFor="campaignCost" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.cost}</label>
                                            <input style={{ direction: isRTL ? 'rtl' : 'ltr' }} value={state.campaignCost} type="number" min={0} id="campaignCost" name="campaignCost" className="form-control" onChange={(e) => handleChangeState('campaignCost', e.target.value)} required validate placeholder="أدخل التكلفة..." />
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                            </div>
                            <div className="drawer-action-footer">
                                <MDBBtn type="button" className="btn-cancel" onClick={toggle}>
                                    إلغاء
                                </MDBBtn>
                                <MDBBtn type="submit" className="btn-submit">
                                    {allStrings.send}
                                </MDBBtn>
                            </div>
                        </form>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </MDBModalBody>
    </MDBModal>
);


export const MediaTable = ({ state, props, allStrings, removeAsset, toggleMedia, onPageChange }) => {
    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: allStrings.type,
            key: 'mediaType',
            render: (val) => {
                const typeMap = {
                    IMAGE: allStrings.image || (props.isRTL ? 'صورة' : 'Image'),
                    VIDEO: allStrings.video || (props.isRTL ? 'فيديو' : 'Video')
                };
                return typeMap[val.mediaType] || val.mediaType;
            }
        },
        {
            title: allStrings.file,
            key: 'file',
            render: (val) => val.media ? (
                <a style={{ fontSize: '15px', fontWeight: '600', color: '#1D9598', textDecoration: 'none' }}
                    href={val.media} target="_blank" rel="noopener noreferrer" title="">
                    {allStrings.showFile}
                </a>
            ) : null
        }
    ];

    return (
        <InsideTable
            isRTL={props.isRTL}
            allStrings={allStrings}
            data={state.assets}
            columns={columns}
            removeAction={removeAsset}
            toggleMedia={toggleMedia}
            loading={state.loading}
            title={allStrings.marketingContent}
            addBtnTitle='اضافه محتوى جديد'
            subtitle="إدارة جميع ملفات وأنواع محتوى التسويق الخاص بالمشروع"
            page={state.page2}
            pages={state.pages2}
            onPageChange={onPageChange}
        />
    );
};
export const AttachmentsTable = ({ state, props, allStrings, removeAttachment, toggleAttachment, onPageChange }) => {
    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: allStrings.content,
            dataIndex: 'content',
            key: 'content'
        },
        {
            title: allStrings.file,
            key: 'file',
            render: (val) => val.file ? (
                <a style={{ fontSize: '15px', fontWeight: '600', color: '#1D9598', textDecoration: 'none' }}
                    href={val.file} target="_blank" rel="noopener noreferrer" title="">
                    {allStrings.showFile}
                </a>
            ) : null
        },
        {
            title: allStrings.startDate,
            dataIndex: 'startDate',
            key: 'startDate'
        },
        {
            title: allStrings.endDate,
            dataIndex: 'endDate',
            key: 'endDate'
        },
        {
            title: allStrings.status,
            key: 'status',
            render: (val) => {
                const isActive = val.status === 'ACTIVE' || val.status === 'active' || val.status === true;
                return (
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                        <span style={{
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: isActive ? '#28a745' : '#dc3545',
                            display: 'inline-block'
                        }} />
                        <span>{isActive ? (allStrings.active || 'نشط') : (allStrings.inactive || 'غير نشط')}</span>
                    </div>
                );
            }
        },
    ];

    return (
        <InsideTable
            isRTL={props.isRTL}
            allStrings={allStrings}
            data={state.attachments}
            columns={columns}
            removeAction={removeAttachment}
            toggleMedia={toggleAttachment}
            loading={state.loading}
            title={allStrings.attachments}
            addBtnTitle='اضافه ملف جديد'
            subtitle="إدارة جميع الملفات والتراخيص الخاصة بالمشروع"
            page={state.page3}
            pages={state.pages3}
            onPageChange={onPageChange}
        />
    );
};
export const CampaignsTable = ({ state, props, allStrings, removeCampaign, toggleCampaign, onPageChange }) => {
    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: allStrings.content,
            dataIndex: 'content',
            key: 'content'
        },
        {
            title: allStrings.type,
            key: 'type',
            render: (val) => {
                const typeMap = {
                    SNAPCHAT: allStrings.snapChat || (props.isRTL ? 'سناب شات' : 'Snapchat'),
                    FACEBOOK: allStrings.facebook || (props.isRTL ? 'فيسبوك' : 'Facebook'),
                    INSTAGRAM: allStrings.instagram || (props.isRTL ? 'انستجرام' : 'Instagram'),
                    TIKTOK: allStrings.tiktok || (props.isRTL ? 'تيك توك' : 'TikTok'),
                    BOARD: allStrings.board || (props.isRTL ? 'لوحة إعلانية' : 'Board'),
                    NONE: allStrings.other || (props.isRTL ? 'أخرى' : 'Other')
                };
                return typeMap[val.type] || val.type;
            }
        },
        {
            title: allStrings.cost,
            dataIndex: 'cost',
            key: 'cost'
        },
    ];

    return (
        <InsideTable
            isRTL={props.isRTL}
            allStrings={allStrings}
            data={state.campaigns}
            columns={columns}
            removeAction={removeCampaign}
            toggleMedia={toggleCampaign}
            loading={state.loading}
            title={allStrings.campaigns}
            addBtnTitle='اضافه سجل جديد'
            subtitle="إدارة جميع الحملات الاعلانيه الخاصة بالمشروع"
            page={state.page4}
            pages={state.pages4}
            onPageChange={onPageChange}
        />
    );
};

// Component for the main card content 
export const MainCardContent = ({ state, isRTL, allStrings, submitHandler, changeHandler, deleteRequest, notAvailable, fileChangedHandler, removeFile, handleChangeState, headers, canSeeReport, toggle, canDoFinancialCollection, toggleMedia }) => {
    const showTargetSales = state.targetSales && state.targetSales.length > 0 &&
        !(state.actionType === "VIEW" && state.targetSales.length === 1 && !state.targetSales[0].monthDate && !state.targetSales[0].ratio && !state.targetSales[0].target);

    return (
        <CardContent style={{ minHeight: "390px", outline: 'none' }}>
            <MDBContainer>
                <MDBRow>
                    <MDBCol md="12">
                        <form
                            className="needs-validation"
                            onSubmit={submitHandler}
                            noValidate
                        >

                            <div className="grey-text">
                                {state.actionType === "VIEW" &&
                                    <MDBRow style={{ flexDirection: isRTL ? 'row-reverse' : 'row' }}>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                                <label htmlFor="form8" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>#</label>
                                                <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.id} type="text" id="form8" className="form-control" onChange={changeHandler} required validate />
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                                <label htmlFor="form8" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.status}</label>
                                                <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.available ? allStrings.available : allStrings.notAvailable} type="text" id="form8" className="form-control" required validate />
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                }
                                <MDBRow>
                                    <MDBCol md="6">
                                        <div className="md-form">
                                            <label htmlFor="form65" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.englishName}</label>
                                            <input disabled={state.actionType === "VIEW" ? true : false} onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9-,.@%$؟'"?#*&()_^&!\\/\s-_]/g, '')} style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.name_en} type="text" id="form645" name="name_en" className="form-control" onChange={changeHandler} required validate placeholder="أدخل الاسم بالانجليزية..." />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                        <div className="md-form">
                                            <label htmlFor="form56" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.arabicName}</label>
                                            <input disabled={state.actionType === "VIEW" ? true : false} onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^\u0600-\u06FF0-9\u0660-\u0669#.,@?؟%$_^*()/\\ _-]+/g, '')} style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.name_ar} type="text" id="form56" name="name_ar" className="form-control" onChange={changeHandler} required validate placeholder="أدخل الاسم بالعربية..." />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="6">
                                        <div className="md-form">
                                            <label htmlFor="form65" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.tag}</label>
                                            <input disabled={state.actionType === "VIEW" ? true : false} onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9-,.@%$؟'"?#*&()_^&!\\/\s-_]/g, '')} style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.tag} type="text" id="form645" name="tag" className="form-control" onChange={changeHandler} required validate placeholder="أدخل البيانات..." />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                        <div className="md-form">
                                            <label htmlFor="form65" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.totalPrice}</label>
                                            <input disabled={state.actionType === "VIEW" ? true : false} style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.totalPrice} type="number" min={0} id="form645" name="totalPrice" className="form-control" onChange={changeHandler} required validate placeholder="أدخل السعر الإجمالي..." />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div className="md-form">
                                            <label htmlFor="form65" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.profileUrl}</label>
                                            <input placeholder="أدخل رابط البروفايل..." disabled={state.actionType === "VIEW" ? true : false} style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.profileUrl} type="text" id="form645" name="profileUrl" className="form-control" onChange={changeHandler} required validate />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div class="md-form">
                                            <label htmlFor="form65" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.englishDescription}</label>
                                            <br></br>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            <textarea disabled={state.actionType === "VIEW" ? true : false} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} value={state.description_en} onChange={changeHandler} type="text" id="form645" name="description_en" class="form-control" placeholder="أدخل الوصف بالانجليزية..." />
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div class="md-form">
                                            <label htmlFor="form56" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.arabicDescription}</label>
                                            <br></br>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            <textarea disabled={state.actionType === "VIEW" ? true : false} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} value={state.description_ar} onChange={changeHandler} type="text" id="form56" name="description_ar" class="form-control" placeholder="أدخل الوصف بالعربية..." />
                                        </div>
                                    </MDBCol>
                                </MDBRow>

                                <MDBRow style={{ flexDirection: isRTL ? 'row-reverse' : 'row' }}>

                                    <MDBCol md="6">
                                        <label className="customLabel" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.supportEmployee}</label>
                                        <TreeSelect virtual={false}
                                            showSearch={true}
                                            value={state.supportEmployee}
                                            disabled={state.actionType === "VIEW" ? true : false}
                                            style={{ width: '100%', textAlign: isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                            treeCheckable={false}
                                            treeNodeFilterProp="title"
                                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                            placeholder={allStrings.supportEmployee}
                                            onChange={(value) => {
                                                console.log(value)
                                                handleChangeState('supportEmployee', value)
                                            }}
                                        >
                                            {Array.isArray(state.users) && state.users.map(val => (
                                                <TreeNode value={val.id} title={val.fullname} key={val.id} />
                                            ))}
                                        </TreeSelect>
                                    </MDBCol>
                                    <MDBCol md="6">
                                        <label className="customLabel" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.employees}</label>
                                        <TreeSelect virtual={false}
                                            showSearch={true}
                                            value={state.employees}
                                            disabled={state.actionType === "VIEW" ? true : false}
                                            style={{ width: '100%', textAlign: isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                            treeCheckable={true}
                                            treeNodeFilterProp="title"
                                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                            placeholder={allStrings.employees}
                                            onChange={(value) => {
                                                console.log(value)
                                                handleChangeState('employees', value)
                                            }}

                                        >
                                            {Array.isArray(state.users) && state.users.map(val => (
                                                <TreeNode value={val.id} title={val.fullname} key={val.id} />
                                            ))}
                                        </TreeSelect>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow style={{ flexDirection: isRTL ? 'row-reverse' : 'row' }}>
                                    <MDBCol md="6">
                                        <div className="md-form">
                                            <label htmlFor="form65" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.ownerName}</label>
                                            <input disabled={state.actionType === "VIEW" ? true : false} style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.ownerName} type="text" id="form645" name="ownerName" className="form-control" onChange={changeHandler} required validate placeholder="أدخل البيانات..." />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                        <div className="md-form">
                                            <label htmlFor="form65" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.ownerPhone}</label>
                                            <input disabled={state.actionType === "VIEW" ? true : false} style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.ownerPhone} type="text" id="form645" name="ownerPhone" className="form-control" onChange={changeHandler} required validate placeholder="أدخل البيانات..." />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow style={{ flexDirection: isRTL ? 'row-reverse' : 'row' }}>
                                    {state.actionType === "EDIT" &&
                                        <MDBCol md="6">
                                            <div className="md-form">
                                                <label htmlFor="form65" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.password}</label>
                                                <input disabled={state.actionType === "VIEW" ? true : false} style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.ownerPassword} type="text" id="form645" name="ownerPassword" className="form-control" onChange={changeHandler} validate placeholder="أدخل كلمة المرور..." />
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    }
                                    <MDBCol md={state.actionType === "VIEW" ? "12" : "6"}>
                                        <div className="md-form">
                                            <label htmlFor="form65" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.totalViews}</label>
                                            <input disabled={state.actionType === "VIEW" ? true : false} style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.totalViews} type="number" min={0} id="form645" name="totalViews" className="form-control" onChange={changeHandler} required validate placeholder="أدخل الرقم..." />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div className="md-form">
                                            <label htmlFor="form65" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.commissionRatio}</label>
                                            <input disabled={state.actionType === "VIEW" ? true : false} style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.commissionRatio} type="number" min={0} step="0.01" id="form645" name="commissionRatio" className="form-control" onChange={changeHandler} required validate placeholder="أدخل الرقم..." />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                {state.actionType === "VIEW" &&
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="md-form">
                                                <label htmlFor="form65" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.interestLink}</label>
                                                <input disabled={state.actionType === "VIEW" ? true : false} style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={`https://saaei.co/temporary-campaign/join-our-interest/${state.tag}`} type="url" id="form645" className="form-control" placeholder="أدخل الرابط..." />
                                                <MDBIcon far icon="copy" style={{ position: 'absolute', left: isRTL ? '10px' : 'auto', right: isRTL ? 'auto' : '10px', top: '75%', transform: 'translateY(-50%)', cursor: 'pointer', zIndex: 2 }} onClick={() => {
                                                    navigator.clipboard.writeText(`https://saaei.co/temporary-campaign/join-our-interest/${state.tag}`)
                                                        .then(() => message.success(allStrings.done))
                                                        .catch(err => console.error('Failed to copy: ', err));
                                                }} />
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                }
                                {state.actionType === "VIEW" &&
                                    <MDBRow>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                                <label htmlFor="form65" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.totalCollected}</label>
                                                <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.totalCollected} type="text" id="form645" name="totalCollected" className="form-control" />
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                                <label htmlFor="form65" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.collectedCount}</label>
                                                <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.collectedCount} type="text" id="form645" name="collectedCount" className="form-control" />
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                }
                                {state.actionType === "VIEW" &&
                                    <MDBRow>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                                <label htmlFor="form65" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.totalNotCollected}</label>
                                                <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.totalNotCollected} type="text" id="form645" name="totalNotCollected" className="form-control" />
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                                <label htmlFor="form65" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.notCollectedCount}</label>
                                                <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.notCollectedCount} type="text" id="form645" name="notCollectedCount" className="form-control" />
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                }
                                {state.actionType === "VIEW" &&
                                    <MDBRow>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                                <label htmlFor="form65" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.totalBooked}</label>
                                                <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.totalBooked} type="text" id="form645" name="totalBooked" className="form-control" />
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                                <label htmlFor="form65" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.bookedCount}</label>
                                                <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.bookedCount} type="text" id="form645" name="bookedCount" className="form-control" />
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                }
                                {showTargetSales &&
                                    <label className="labelBox" style={{ margin: '25px 0px', textAlign: isRTL ? 'right' : 'left' }}>
                                        <span>{allStrings.targetSales}</span>
                                    </label>
                                }
                                {showTargetSales && theTargetSales(state, isRTL, allStrings, handleChangeState)}
                                {state.actionType === "EDIT" &&
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="fileUpload2">
                                                <input key={state.img} type='file' className="upImgs2" onChange={fileChangedHandler} ></input>
                                                <span className="uploadParent"><UploadOutlined style={{ color: '#000', fontSize: '14px', position: 'relative', top: '-3px', marginRight: '2px' }} /><span className="uploadName">{allStrings.upload}</span></span>
                                            </div>
                                            <div className="preview">
                                                {state.img &&
                                                    <div style={{ display: "inline-block", width: '100%', border: '1px solid mediumaquamarine' }}>
                                                        <img alt="" src={state.imgType === "data" ? URL.createObjectURL(state.img) : state.img} className="previewImg2" />
                                                        <span className="imgName">{state.imgName}</span>
                                                        <MDBIcon icon="trash" className="mr-2 removeImg2"
                                                            onClick={() => removeFile()}  ></MDBIcon>
                                                    </div>
                                                }
                                            </div>

                                        </MDBCol>
                                    </MDBRow>
                                }
                            </div>
                            <br></br>
                            <br></br>
                            <div className="text-center">
                                {state.actionType === "EDIT" &&
                                    <MDBBtn
                                        style={{ background: 'linear-gradient(135deg, #1D9598, #127275)', color: '#fff' }}
                                        rounded
                                        color="#1D9598"
                                        type="submit"
                                        className="btn-block z-depth-1a"
                                    >
                                        <MDBIcon icon="edit" className="mr-2" />
                                        {allStrings.update}
                                    </MDBBtn>
                                }
                            </div>
                        </form>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </CardContent>
    );
}